import {
  ConfirmEmailChangeRequest,
  ConfirmEmailChangeResponse,
} from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type ConfirmEmailChangeOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  token: string;
};

export const confirmEmailChange = async <TFunctions>(
  options: ConfirmEmailChangeOptions<TFunctions>,
): Promise<ConfirmEmailChangeResponse> => {
  const { functions, httpsCallable, token } = options;
  const callable = httpsCallable<
    ConfirmEmailChangeRequest,
    ConfirmEmailChangeResponse
  >(functions, 'users-confirmEmailChange');

  return (await callable({ token })).data;
};
